import React from "react";

import { INotificationContext } from "./types";

export const NotificationContext = React.createContext<INotificationContext>(
  {},
);

export const NotificationContextProvider: React.FC<
  React.PropsWithChildren<INotificationContext>
> = ({ open, close, children }) => {
  return (
    <NotificationContext.Provider value={{ open, close }}>
      {children}
    </NotificationContext.Provider>
  );
};
